import { useContext } from "react";
import { AuthContext } from "./authContext";
import { getTokenPermissions } from "./tokenUtils";

/**
 * Whether the signed-in token carries a permission. It only decides what the UI shows;
 * the API enforces the permission on every request.
 */
export function useHasPermission(permission: string): boolean {
  const auth = useContext(AuthContext);
  return getTokenPermissions(auth?.token ?? null).includes(permission);
}
